import React, { Component } from 'react';
import * as Media from '../../utils/Breakpoints';



class ImageComponent extends Component {

  loading=0;
  timer=0;

  shouldComponentUpdateOff = (nextProps,nextState) => {
    //console.log(this.props,this.state,nextState);
    

  }
	constructor(props) {
    super(props);
    this.state = {width:0,loaded:0};
  }

  componentDidMount() {
      
      let lazy = 1;
      if(this.props.hasOwnProperty('lazy') && (this.props.lazy === false)) lazy = 0;
      let loaded = (lazy) ? 0 : 1;

      this.setState({lazy:lazy,visible:false,width:this.refs.image.offsetWidth,loaded:loaded,height:this.refs.image.offsetHeight});
      if(!loaded){
        setTimeout(this.listen,50);
        this.startListener();
      }

	}

  componentDidUpdate() {
      let wChanged = this.refs.image.offsetWidth != this.state.width;
      let hChanged = this.refs.image.offsetHeight != this.state.height;

      if(wChanged || hChanged) this.setState({width:this.refs.image.offsetWidth,height:this.refs.image.offsetHeight});
  }

	componentWillUnmount() {
      this.stopListener();
	  }


    startListener = () => {

        let checkTimer = (this.props.hasOwnProperty('checkTimer')) ? this.props.checkTimer : 1000;
        this.timer = setInterval(this.listen,checkTimer);

    }
    load = (src) => {

        if(this.loading || this.state.loaded) return;

        this.loading = 1;
        let i = new Image();
        let _this = this;
        _this.image = i;

        i.onload = function(){
          
          //console.log('loaded',src);
          if(!_this.state.loaded){
            _this.setState({loaded:1});
            if(_this.props.onLoad) _this.props.onLoad();
          }

        }

        setTimeout(()=>{
          if(!i.complete){
            _this.setState({loaded:1});
            if(_this.props.onLoad) _this.props.onLoad();
          }
        },3000)

        i.src = src;

    }
    

    stopListener = () => {

        clearInterval(this.timer);

    }

    listen = () => {


        if(!this.refs.image) return;
        //if(this.props.debug) console.log('listen...');
        
        let threshold = window.innerHeight; // Precision for how close to viewport bounds is deemed 'visible'

        let wasVisible = this.state.visible;


        // Is visible?
       let offset = this.refs.image.getBoundingClientRect();
      
       let imageHeight = Math.abs(offset.top - offset.bottom);
       let imageWidth = Math.abs(offset.left - offset.right);

       let topVisible = (offset.top < (window.innerHeight + threshold));
       let bottomVisible = (offset.bottom > (-threshold));

       let leftVisible = (offset.left < (window.innerWidth + threshold));
       let rightVisible = (offset.right > (-threshold));


       let largerThanViewport = ((offset.top < 0)&& (offset.bottom > window.innerHeight));

        let isVisible = (offset.width > 0) && ((topVisible && bottomVisible && leftVisible && rightVisible) || largerThanViewport);

        let hasChanged = ((isVisible != wasVisible) || (offset.width != this.state.width) || (offset.height != this.state.height));

        

        let visibility = (this.props.checkVisible) ? isVisible : (isVisible||wasVisible);


      if( hasChanged ) this.setState({visible:visibility,width:offset.width,height:offset.height},()=>{

        if(this.props.lazy && isVisible && !this.loading && !this.state.loaded){

          let src = this.refs.image.getAttribute('data-src');
          //console.log('Load',src);
          if(src) this.load(src);

        }

      });



    }


  render() {

 
	const ratioStyle = {

  		paddingTop:(100 / (this.props.ratio))+'%'

  	}
  	const fluidStyle = {

  		width:'100%',
  		height:'100%',
      position:'absolute',
      top:0,
      left:0

  	}

  	const style = (this.props.fluid) ? fluidStyle : ratioStyle;

    let className = this.props.className || '';

    if(this.props.fluid) className += " Image--fluid";

    if(this.state.visible) className += " Image--visible";

    if(this.state.loaded) className += " Image--loaded";
   
    if(this.props.orientation) className += " Image--orientation-"+this.props.orientation;

    if(this.state.lazy) className += " Image--lazy";

    const fallback = this.props.large || this.props.small || this.props.src;
    const small = (this.props.small) ? this.props.small : this.props.src;
    const medium = (this.props.medium) ? this.props.medium : this.props.src;
    const large = (this.props.large) ? this.props.large : this.props.src;

    
    if(this.props.lazy && (!this.refs.image || !this.state.visible || !this.state.width )) return <div className={'Image '+className} ref="image" style={style}><div className="Image-media" title={this.props.title} /></div>

    // Is the image being displaed at a rtio outside of its natural prortions? If so, recalculate therequired size
    let scale = (this.props.ratio / (this.state.width/this.state.height) );
    
    scale = (isNaN(scale) || scale < 0.9) ? 0 : scale; 
    
    let longest = (Math.max(this.state.width,this.state.height));

    let w = (scale) ? (longest * window.devicePixelRatio * scale) : 3000; // No scale, load the largest version

    let size = 'large';

    let src;

    src = large;
    if(w < 1000) src = medium;
    if(w < 600) src = small;
    


    if(!src) src = fallback;

    if(w < 1000) size = 'medium'
    if(w < 600) size = 'small';

    //console.log(this.props.svg)

    if(this.props.svg) src = this.props.svg 
      
      if(!src) src = '';

    //src = 'https://images.unsplash.com/photo-1594643551111-29af420564e8?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=500&q=60';

      let parts = src.split('.');
      let ext = this.props.extension || parts[parts.length-1];

    if(this.props.lazy && !this.state.loaded){
      
      return (<div className={'Image Image--loading '+className} data-visible={this.state.visible} ref="image" data-src={src} data-extension={ext} style={style}><div className="Image-media" title={this.props.title} />
          {(()=>{



          })()}
      </div>)
    }

    return (
      <div className={'Image '+className} ref="image" style={style} data-debug={(this.props.debug) ? Math.random() : false} data-visible={this.state.visible} data-extension={ext} data-width={w} data-scale={scale}>
           {(()=>{

              if(this.props.useImg){
                return (<img src={src} className="Image-media" data-title={this.props.title || null} alt={this.props.alt || null} />)
              }else{
                return <div className="Image-media" role="img" aria-label={this.props.title} style={{backgroundImage:"url("+src+")"}} data-title={this.props.title} />
              }

           })()}
 		       
 		       {(()=>{

              if(this.props.raw){
                return (<img src={src} className="Image-raw" data-title={this.props.title || null} alt={this.props.alt || null} style={{opacity:0,display:'block',zIndex:1,...fluidStyle}} />)
              }

           })()}
           
      </div>
    );
  }
}

export default ImageComponent;



// WEBPACK FOOTER //
// ./src/js/_core/components/Image/Image.jsx